import { de, enUS } from 'date-fns/locale'

const LOCALES = { de, en: enUS }

/**
 * The date-fns locale matching the language the UI is currently rendered in.
 *
 * Pass this to every date-fns call that emits words (formatDistanceToNow, format with
 * EEEE/MMMM tokens, ...). Hardcoding `de` there puts German inside otherwise English
 * sentences - "The last import was cancelled weniger als 1 Minute ago".
 *
 * The i18n singleton is resolved lazily, NOT imported at module scope: filters.js is pulled
 * in very early by main.js, and an eager import would drag @/i18n -> SetupApi -> @/store/apollo
 * into that early graph, constructing the Apollo client before auth is ready and breaking
 * login. Resolving on call keeps the import graph exactly as it was.
 */
export function activeDateLocale() {
    let locale

    try {
        locale = require('@/i18n').default.locale
    } catch (error) {
        locale = undefined
    }

    return LOCALES[locale] || enUS
}
